import(/* webpackMode: "eager" */ "/app/src/app/(app)/chats/page.tsx");
